import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { PropsWithChildren } from "react";

import css from "./hint_wrapper.module.scss";

type HintWrapperProps = PropsWithChildren<{
  qaId?: string;
  hint: React.ReactNode;
}>;

export const HintWrapper = ({ qaId, hint, children }: HintWrapperProps) => (
  <Inline qaId={qaId} alignItems="center" gap="spacingLg">
    <div className={css.field}>{children}</div>
    <Typography variant="labelRegular" className={css.hint}>
      {hint}
    </Typography>
  </Inline>
);
